import { Controller } from "@hotwired/stimulus"

// Floating FAB controller - reveals label on hover/focus/press
export default class extends Controller {
  connect() {
    this.collapseTimeout = null
  }

  expand() {
    if (this.collapseTimeout) {
      clearTimeout(this.collapseTimeout)
      this.collapseTimeout = null
    }
    this.element.classList.add("is-expanded")
  }

  collapse() {
    this.collapseTimeout = setTimeout(() => {
      this.element.classList.remove("is-expanded")
    }, 120)
  }
}
